const config = [
  {
    code: 404,
    description: '路径不存在',
    path: '/error'
  },
  {
    code: 500,
    description: '系统异常',
    path: '/error'
  },
  {
    code: 401,
    description: '尚未登录',
    path: '/error'
  }
]
export default config



// WEBPACK FOOTER //
// ./src/config/error-handler.js